// Parse value to float with fixed decimal point to (fraction digits) and remove period.
export const formatValueToCurrency = (
	value: string,
	fractionDigits = 2,
): string => {
	return value
		? parseFloat(value).toFixed(fractionDigits).replace(/[.]/g, '')
		: ''
}
